import { fetchAPI } from './client';

export interface Identity {
  id: string;
  provider: string;
  email?: string;
}

export const AuthAPI = {
  login: async (
    email: string,
    password: string,
  ): Promise<{ message: string; mfaRequired: boolean }> => {
    return fetchAPI('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  },

  logout: async (): Promise<{ message: string }> => {
    return fetchAPI('/auth/logout', {
      method: 'POST',
    });
  },

  forgotPassword: async (email: string): Promise<void> => {
    return fetchAPI('/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({email})
    });
  },

  verifyResetToken: async (tokenHash: string): Promise<void> => {
    return fetchAPI('/auth/verify-reset-token', {
      method: 'POST',
      body: JSON.stringify({tokenHash})
    });
  },

  updatePassword: async (password: string): Promise<void> => {
    return fetchAPI('/auth/update-password', {
      method: 'POST',
      body: JSON.stringify({password})
    });
  },

  oauthCallback: async (
    code: string,
    codeVerifier: string,
  ): Promise<{ message: string; mfaRequired: boolean }> => {
    return fetchAPI('/auth/oauth/callback', {
      method: 'POST',
      body: JSON.stringify({ code, codeVerifier }),
    });
  },

  getGoogleLinkUrl: async (codeChallenge: string): Promise<{ authorizeUrl: string }> => {
    return fetchAPI(`/auth/google/link?code_challenge=${encodeURIComponent(codeChallenge)}`);
  },

  completeGoogleLink: async (code: string, codeVerifier: string): Promise<void> => {
    await fetchAPI('/auth/google/link/complete', {
      method: 'POST',
      body: JSON.stringify({ code, codeVerifier }),
    });
  },

  listIdentities: async (): Promise<Identity[]> => {
    return fetchAPI('/auth/identities');
  },
};